import React, { useEffect, useState } from 'react';
import { raw } from '../../translations/en/raw';
import { datePickerObjToISOFormat, humanizeWithoutId } from '../../utilities/functions';
import classes from './ParamsForm.module.css';
import Select from 'react-select'
import DatePicker from "react-multi-date-picker";
import ColourPicker from '../ColourPicker/ColourPicker';

const ParamsForm = (props) => {
    // state
    const [internalData, setInternalData] = useState();
    
    // props
    const data = props.data;
    const setData = props.setData;
    const config = props.config;

    // console logs
    // console.log('[ParamsForm]-  internalData: ', internalData)
    // console.log('[ParamsForm]-  data: ', data)

    const handleValidation = (value, validationRules) => {

        let validationPassed = true;

        if (validationRules.onlyNumbers) {
            // validationPassed = validationPassed && /^\d+$/.test(value);
            // validationPassed = validationPassed && /[0-9 ]+/.test(value);
            // validationPassed = validationPassed && /^(\s*|\d+)$/.test(value);
            validationPassed = validationPassed && /^[0-9 ]*$/.test(value);
        }

        // console.log('checking validation for: ', value);
        // console.log('validation rules: ', validationRules);
        return validationPassed;
    }

    // console logs
    // console.log('config: ', config);
    // console.log('data: ', data);
    // console.log('internal data: ', internalData);
    
    // initialise data object with specified values 
    useEffect(() => {
        // if (!internalData) {

            let newData = {...data};
            for (const obj of config) {
                if (obj.value) {
                    newData = {
                        ...newData,
                        [obj.name]: obj.value
                    };
                }
            }
            // console.log('initalised internal data');
            setInternalData(newData);
        // }

    }, [config, data])

    let rows = [];
    for (const obj of config) {

        // render input as per type specified
        let input;
        const type = obj.type;
        
        // render value depending on whether specified or not
        let value;
        const specifiedValue = obj.value;
        if (specifiedValue) {
            value = specifiedValue;
        } else {
            value = data?.[obj.name] ?? '';
        }

        // deal with dates
        if (type === 'date') {
            value = value.slice(0,10);
        }

        if (type === 'checkbox') {
            input = (
                <input 
                    type={type} 
                    className='form-check-input' 
                    checked={value} 
                    onChange={(e) => {
                        const newData = {...internalData, [obj.name] : e.target.checked};
                        setData(newData);
                        setInternalData(newData);
                    }}
                    disabled={specifiedValue ? true : false}

                />                 
            );
        } else if (type === 'select') {
            const options = obj.options;
            input = (
                <select
                    className='form-control' 
                    value={value} 
                    onChange={(e) => {
                        const newData = {...internalData, [obj.name] : e.target.value};
                        setData(newData);
                        setInternalData(newData);
                    }}   
                    disabled={specifiedValue ? true : false}             
                >
                    {options.map(op => <option key={op.value} value={op.value}>{op.label}</option>)}
                </select>


            );

        } else if (type === 'react-select') {
            // const options = obj.options;
            // override value
            const valueProperty = obj?.valueProperty ?? 'value';
            // console.log('value: ', value);
            let arrayUniqueByKey = [...new Map(obj?.options?.map(item =>
                [item['value'], item])).values()];
            console.log(arrayUniqueByKey);
            // single
            let reactSelectValue;
            if (obj.isMulti) {
                reactSelectValue = obj?.options?.filter(op => value.includes(op[valueProperty]));

            } else {
                reactSelectValue = obj?.options?.filter(op => op[valueProperty]?.toString() === value?.toString())?.[0] ?? {};
            }
            
            // console.log('reactSelectValue: ', reactSelectValue);
            // console.log('name: ', obj.name);
            // console.log('allowOverride: ', obj.allowOverride);
            input = (
                <div style={{width: '100%'}}>
                    <Select
                        value={reactSelectValue} 
                        onChange={(e) => {
                            console.log('e: ', e);
                            let newData;
                            if (e?.length >= 1) {
                                
                                // multi select
                                const newValue = e.map(obj => obj[valueProperty]);
                                newData = {...internalData, [obj.name] : newValue};

                            } else {
    
                                // single select
                                const newValue = e[valueProperty];
                                newData = {...internalData, [obj.name] : newValue};

                            }

                            setData(newData);
                            setInternalData(newData);
                        }}                
                        options={obj.unique ? arrayUniqueByKey : (obj?.sort ? obj?.options?.sort((a,b) => a.value - b.value) : obj.options)}
                        // options={obj.unique ? arrayUniqueByKey : obj.options}
                        disabled={specifiedValue ? true : false}
                        isMulti={obj.isMulti}
                    >
                    </Select>
                </div>

                // <Select isMulti options={childOptions} onChange={setSelectedChildren} value={selectedChildren} ></Select>    


            );

        } else if (type === 'date-picker') {

            input = (
                <div style={{width: '100%'}}>
                    <DatePicker 
                    inputClass="form-control" 
                    placeholder="Select Date" 
                    value={value} 
                    fixMainPosition={true} 
                    format='YYYY-MM-DD' 
                    multiple
                    onChange={(e) => {

                        const dates = [];
                        for (const dateObj of e) {
                            console.log('date picker test, e: ', dateObj);
                            console.log('date picker test, date of e: ', datePickerObjToISOFormat(dateObj));
                            const newDate = datePickerObjToISOFormat(dateObj);
                            dates.push(newDate)
                        }

                        const newData = {...internalData, [obj.name] : dates};
                        setData(newData);
                        setInternalData(newData);
                    }}  
                    // onChange={(e) => {setSelectedDates(e);}}
                    />
                </div>
            );
        } else if (type === 'colour-picker'){
            input = (
                <div style={{width: '100%'}}>
                    <ColourPicker 
                        onChange={(newColour) => {
                            const newData = {...internalData, [obj.name] : newColour}
                            setData(newData);
                            setInternalData(newData);
                        }}
                    />
                </div>
            );
        } else if (type === 'textarea') {
            input = (
                <textarea 
                    className='form-control' 
                    value={value} 
                    onChange={(e) => {
                        
                        // check validation rules
                        let validationPassed = true;
                        if (obj.validation) {
                            validationPassed = handleValidation(e.target.value, obj.validation);

                        }
                        
                        // on validation failure
                        if (validationPassed) {
                            const newData = {...internalData, [obj.name] : e.target.value};
                            setData(newData);
                            setInternalData(newData);
                        } else {
                            return false;
                            
                        }
                        
                    }}
                    disabled={specifiedValue ? true : false}
                    
                    /> 
                    );            
        } else {
            input = (
                <input 
                    type={type} 
                    className='form-control' 
                    value={value} 
                    onChange={(e) => {
                        
                        // check validation rules
                        let validationPassed = true;
                        if (obj.validation) {
                            validationPassed = handleValidation(e.target.value, obj.validation);

                        }
                        
                        // on validation failure
                        if (validationPassed) {
                            const newData = {...internalData, [obj.name] : e.target.value};
                            setData(newData);
                            setInternalData(newData);
                        } else {
                            return false;
                            
                        }
                        
                    }}
                    disabled={specifiedValue ? true : false}
                    
                    /> 
                    );
        }


        if (type === 'checkbox') {
            rows.push(
                <div key={obj.name} className={[classes.CheckboxRow, 'form-check'].join(' ')}>
                    {input}
                    <span className={classes.Label}>{raw[obj.name] ?? humanizeWithoutId(obj.name) ?? obj.name}</span>
                </div>
            );

        } else {
            rows.push(
                <div key={obj.name} className={classes.Row}>
                    <span className={classes.Label}>{raw[obj.name] ?? humanizeWithoutId(obj.name) ?? obj.name}</span>
                    {input}
                </div>
            );

        }
    }


    return (
        <div key="container" className={classes.ParamsForm}>
            {rows}
        </div>
        

    );
};

export default ParamsForm;